import React from 'react';
import { Link } from '@material-ui/core';

interface SafeAnchorProps {
  href: string
  rel?: string
  target?: string
  children?: React.ReactNode
}

const SafeAnchor = React.forwardRef<HTMLAnchorElement, SafeAnchorProps>(
  ({ href, children, ...props }: SafeAnchorProps, ref) => {
    function onClick (event: React.MouseEvent<HTMLAnchorElement>) {
      event.stopPropagation();
      const url = new URL(href, window.location.href);
      if (!['http:', 'https:'].includes(url.protocol)) {
        event.preventDefault();
      }
    }

    return (
      <Link ref={ref} href={href} {...props} onClick={onClick}>
        {children}
      </Link>
    );
  });

export default SafeAnchor;
